var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlinePercentageSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "745D337F-1AD4-408D-B994-B489F773990C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Money",
    transform: "translate(-556.000000, -252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "percentage-square",
    transform: "translate(556.000000, 252.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,22.75 C3.57000017,22.75 1.25,20.4299998 1.25,15 L1.25,9 C1.25,3.57000017 3.57000017,1.25 9,1.25 L15,1.25 C20.4299998,1.25 22.75,3.57000017 22.75,9 L22.75,15 C22.75,20.4299998 20.4299998,22.75 15,22.75 L9,22.75 Z M2.75,9 L2.75,15 C2.75,19.6100001 4.38999987,21.25 9,21.25 L15,21.25 C19.6100001,21.25 21.25,19.6100001 21.25,15 L21.25,9 C21.25,4.38999987 19.6100001,2.75 15,2.75 L9,2.75 C4.38999987,2.75 2.75,4.38999987 2.75,9 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03976563,15.8001418 C7.74976563,15.5101418 7.74976563,15.0301442 8.03976563,14.7401443 L14.5897536,8.19015625 C14.8797536,7.90015626 15.3597512,7.90015626 15.6497512,8.19015625 C15.9397512,8.48015624 15.9397512,8.96015379 15.6497512,9.25015378 L9.09976315,15.8001418 C8.94976315,15.9501418 8.75976437,16.0201426 8.56976438,16.0201426 C8.37976438,16.0201426 8.18976563,15.9501418 8.03976563,15.8001418 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,9.12991333 C7,8.0399133 7.89001095,7.14990234 8.98001099,7.14990234 C10.070011,7.14990234 10.9599915,8.0399133 10.9599915,9.12991333 C10.9599915,10.2199134 10.070011,11.1098938 8.98001099,11.1098938 C7.89001095,11.1098938 7,10.2199134 7,9.12991333 Z M8.5,9.1399231 C8.5,9.40992311 8.71001098,9.61990356 8.98001099,9.61990356 C9.250011,9.61990356 9.45999146,9.40992311 9.45999146,9.1399231 C9.45999146,8.86992308 9.24001098,8.65991211 8.98001099,8.65991211 C8.720011,8.65991211 8.5,8.86992308 8.5,9.1399231 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5390625,14.8598633 C13.5390625,13.7698632 14.4290429,12.8798828 15.519043,12.8798828 C16.609043,12.8798828 17.499054,13.7698632 17.499054,14.8598633 C17.499054,15.9498633 16.609043,16.8398743 15.519043,16.8398743 C14.4290429,16.8398743 13.5390625,15.9498633 13.5390625,14.8598633 Z M15.0390625,14.869873 C15.0390625,15.1398731 15.249043,15.349884 15.519043,15.349884 C15.789043,15.349884 15.999054,15.1398731 15.999054,14.869873 C15.999054,14.599873 15.789043,14.3898926 15.519043,14.3898926 C15.259043,14.3898926 15.0390625,14.599873 15.0390625,14.869873 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlinePercentageSquare);
export default __webpack_public_path__ + "static/media/vuesax-outline-percentage-square.659d502ea745877290fd86d1536c8242.svg";
export { ForwardRef as ReactComponent };